import type { Lang } from '../../lib/i18n'

// R572 (c): the cash-out form's own dictionary, the same shape as
// features/settings/settings-i18n.ts. Every Arabic value is a placeholder until Rook's vault
// file is copied in by DC's pinned fill; nobody types the Arabic here.
const EN = {
  title: 'Cash out',
  intro: 'Raise a cash out here. The till pays it from the drawer, and the day counts it.',
  quietDay: 'A day with no sales and no cash outs is not counted.',
  ownerAdminOnly: 'This is for the owner and admins.',
  payeeKind: 'Who is paid',
  kindStaff: 'Staff',
  kindExternal: 'External',
  payeeName: 'Name',
  amount: 'Amount (USD)',
  amountHint: 'Dollars and cents, for example 12.50',
  reason: 'Reason',
  submit: 'Raise cash out',
  submitting: 'Raising...',
  needKind: 'Choose staff or external',
  needName: 'Type the name',
  needAmount: 'Type the amount as dollars and cents, for example 12.50',
  needReason: 'Type the reason',
  raised: 'Cash out raised: {payee}, ${amount}. The till pays it.',
  raisedList: 'Raised on this page',
  statusOpen: 'Open, waiting for the till',
  error403: 'Only the owner or an admin can raise a cash out.',
  errorNetwork: "Couldn't reach the server. Check the connection and try again.",
  errorOther: "Couldn't raise it. Try again.",
}

type CashOutKey = keyof typeof EN

const AR: Record<CashOutKey, string> = {
  title: 'صرف نقدي',
  intro: 'اطلب صرفاً نقدياً من هنا. الصندوق يدفعه من الدرج، واليوم يحسبه.',
  quietDay: 'اليوم الذي لا مبيعات فيه ولا صرف نقدي لا يُعدّ.',
  ownerAdminOnly: 'هذه الصفحة للمالك والمديرين.',
  payeeKind: 'لمن يُدفع',
  kindStaff: 'موظف',
  kindExternal: 'جهة خارجية',
  payeeName: 'الاسم',
  amount: 'المبلغ (دولار)',
  amountHint: 'بالدولار والسنت، مثلاً 12.50',
  reason: 'السبب',
  submit: 'اطلب الصرف النقدي',
  submitting: 'جارٍ الطلب...',
  needKind: 'اختر موظفاً أو جهة خارجية',
  needName: 'اكتب الاسم',
  needAmount: 'اكتب المبلغ بالدولار والسنت، مثلاً 12.50',
  needReason: 'اكتب السبب',
  raised: 'تم طلب الصرف النقدي: {payee}، ${amount}. الصندوق يدفعه.',
  raisedList: 'ما طُلب في هذه الصفحة',
  statusOpen: 'مفتوح، بانتظار الصندوق',
  error403: 'المالك أو المدير فقط يمكنه طلب صرف نقدي.',
  errorNetwork: 'تعذّر الوصول إلى الخادم. تحقّق من الاتصال وحاول مجدداً.',
  errorOther: 'تعذّر الطلب. حاول مجدداً.',
}

const CASH_OUT_DICT: Record<Lang, Record<CashOutKey, string>> = { en: EN, ar: AR }

export type { CashOutKey }

export function cx(lang: Lang, key: CashOutKey, vars: Record<string, string | number> = {}): string {
  let out = CASH_OUT_DICT[lang][key]
  for (const [name, value] of Object.entries(vars)) out = out.replace(`{${name}}`, String(value))
  return out
}

export const CASH_OUT_EN = EN
